import NullGeneric from "../../../components/NullGeneric/NullGeneric";
import React from "react";

import { IPetItemResponse } from "../../../services/Standard-of-care/standard-of-care.interface";
import { useBookAppointment } from "../../../hooks/useBookAppointment";

type Props = {
  petData: IPetItemResponse;
  referredFrom: string;
};

const HealthRecordsEmpty = (props: Props) => {
  const { petData, referredFrom } = props;
  const { bookAppointment, isBookingBlocked } =
    useBookAppointment(referredFrom);

  return (
    <div className="h-full flex flex-col justify-center items-center max-h-[31.25rem]">
      <NullGeneric
        image="/assets/icons/pastVisitNull.png"
        title="Your Pet’s List is Empty"
        description="Schedule an appointment to track and review all your pet’s health records."
        handleCTA={() => bookAppointment(petData)}
        isButtonDisabled={isBookingBlocked}
        contentClassName="max-w-[25rem]"
        buttonClassName="!h-10 !rounded-full"
      />
    </div>
  );
};

export default HealthRecordsEmpty;
